<template>
  <div
    class="c-icon"
    :class="{
      'c-icon--colorize': !keepColors,
      'c-icon--small': size === 'small',
      'c-icon--large': size === 'large'
    }"
    v-html="require(`@/assets/icons/${icon}.svg`)"
  />
</template>

<script>
// @group Base Components
export default {
  name: 'OIcon',
  props: {
    icon: {
      type: String,
      required: true
    },
    keepColors: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss">
.c-icon {
  display: inline-block;
  height: 2.4rem;
  vertical-align: middle;
  width: 2.4rem;
}

.c-icon--small {
  height: 1.6rem;
  width: 1.6rem;
}

.c-icon--large {
  height: 3.2rem;
  width: 3.2rem;
}

.c-icon--colorize svg * {
  fill: currentColor;
}
</style>
